import { Navigate, Outlet } from "react-router-dom";
import { isTokenValid } from "./isTokenValid";

const ProtectedRoute = ( ) => {
    const userToken = localStorage.getItem("userToken");

    return isTokenValid(userToken)
        ? <Outlet />
        : <Navigate to ="/login" replace />
}

export default ProtectedRoute;